import { watch, unref, computed } from 'vue';
import { t } from '/@/utils/i18n';
import { useTitle as usePageTitle, useFavicon } from '@vueuse/core';
import { useGlobSetting } from '/@/hooks/setting';
import { useRouter } from 'vue-router';
import { useLocaleStore } from '/@/store/modules/locale';

import { REDIRECT_NAME } from '/@/router/constant';
import { useUserStore } from '/@/store/modules/user';
import favIcon from '/@/assets/favicon.ico';
import favIconChina from '/@/assets/favicon-CHINA.ico';
import { AppMode } from '/@/api/sys/model/userModel';

/**
 * Listening to page changes and dynamically changing site titles
 */
export function useTitle() {
  const { title } = useGlobSetting();

  const { currentRoute } = useRouter();
  const localeStore = useLocaleStore();
  const userStore = useUserStore();

  const pageTitle = usePageTitle();
  const icon = useFavicon();
  const showBasicAILogo = computed(() => {
    // 这个地方比较特殊，因为favicon设置有效的一次无法被无效的icon替换
    const hideLogo = userStore.getGlobalConfig?.hideLogo;
    if (typeof hideLogo === 'boolean') {
      return !hideLogo;
    } else {
      return false;
    }
  });

  const isChina = computed(() => {
    return userStore.getGlobalConfig?.runningMode === AppMode.China;
  });

  watch(
    [() => currentRoute.value.path, () => localeStore.getLocale, showBasicAILogo],
    () => {
      const route = unref(currentRoute);

      if (route.name === REDIRECT_NAME) {
        return;
      }

      const tTitle = t(route?.meta?.title as string);
      if (showBasicAILogo.value) {
        icon.value = isChina.value ? favIconChina : favIcon;
      }
      if (showBasicAILogo.value) {
        pageTitle.value = tTitle ? ` ${tTitle} - ${title} ` : `${title}`;
      } else {
        pageTitle.value = '';
      }
      // document.title = tTitle ? ` ${tTitle} - ${title} ` : `${title}`;
    },
    { immediate: true },
  );
}
